export const ANALYST = 'ANALYST';
export const DIGEST = 'DIGEST';
export const BUSINESS = 'BUSINESS';
export const CASUAL = 'CASUAL';